import {
    SUBMIT_SSWP_CONFIG,
    GET_MASTER_SSWP_CONFIGURATIONS,
    DELETE_SSWP_CONFIG,
} from "./types";

import firebase from "firebase/app";

export const getSSWPMasterConfigs = () => {
    return (dispatch) => {
        dispatch({ type: GET_MASTER_SSWP_CONFIGURATIONS.REQUEST });

        try {
            firebase.auth().onAuthStateChanged((user) => {
                if (user == null) {
                    dispatch({ type: GET_MASTER_SSWP_CONFIGURATIONS.FAIL });
                } else {
                    firebase
                        .database()
                        .ref("/collections/master_sswp_v2_config")
                        .on("value", (snapshot) => {
                            dispatch({
                                type: GET_MASTER_SSWP_CONFIGURATIONS.SUCCESS,
                                payload: snapshot.val(),
                            });
                        });
                }
            });
        } catch (e) {
            dispatch({ type: GET_MASTER_SSWP_CONFIGURATIONS.FAIL });
        }
    };
};

export const submitSSWP = (formName, formConfig, formUID, editingForm) => {
    let uuid;
    if (!editingForm) {
        uuid = Math.random().toString(36).substr(2, 9);
        if (formName === "") {
            formName = uuid;
        }
    } else {
        uuid = formUID;
    }
    formConfig.template_name = formName;

    return (dispatch) => {
        dispatch({
            type: SUBMIT_SSWP_CONFIG.REQUEST,
        });

        try {
            firebase.auth().onAuthStateChanged((user) => {
                if (user === null) {
                    dispatch({
                        type: SUBMIT_SSWP_CONFIG.FAIL,
                    });
                } else {
                    firebase
                        .database()
                        .ref(`/collections/master_sswp_v2_config/${uuid}`)
                        .update(formConfig, (snapshot) => {
                            dispatch({
                                type: SUBMIT_SSWP_CONFIG.SUCCESS,
                            });
                        });
                }
            });
        } catch (e) {
            dispatch({
                type: SUBMIT_SSWP_CONFIG.FAIL,
            });
        }
    };
};

export const deleteSSWPConfig = (formUID) => {
    return (dispatch) => {
        dispatch({ type: DELETE_SSWP_CONFIG.REQUEST });

        try {
            firebase.auth().onAuthStateChanged((user) => {
                if (user === null) {
                    dispatch({ type: DELETE_SSWP_CONFIG.FAIL });
                } else {
                    firebase
                        .database()
                        .ref(`/collections/master_sswp_v2_config/${formUID}`)
                        .update({ deleted: true });
                }
            });
        } catch (e) {
            dispatch({ type: DELETE_SSWP_CONFIG.FAIL });
        }
    };
};
